// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart_root__1w831,\ntext[text-anchor='end'],\ntext[text-anchor='middle'] {\n  font-size: 12px; }\n\n.chart_checkbox__2-NSk ~ span {\n  color: #333333;\n  font-size: 12px !important;\n  line-height: 18px; }\n", ""]);
// Exports
exports.locals = {
	"root": "chart_root__1w831",
	"checkbox": "chart_checkbox__2-NSk"
};
module.exports = exports;
